module.exports = __webpack_public_path__ + "img/voice_search.db18964b.png";